import { render, staticRenderFns } from "./CardOrderList.vue?vue&type=template&id=a6dfa6fc&"
import script from "./CardOrderList.vue?vue&type=script&lang=js&"
export * from "./CardOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports